export const formatCPF = (cpf: string) => {
  const one = cpf.slice(0, 3);
  const two = cpf.slice(3, 6);
  const three = cpf.slice(6, 9);
  const four = cpf.slice(9, 12);
  return `${one}.${two}.${three}-${four}`;
};
